import {BrowserModule} from '@angular/platform-browser'
import {NgModule, ErrorHandler} from '@angular/core'
import {FormsModule} from '@angular/forms'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'

import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'

import {environment} from '../environments/environment'
import {AngularFireDatabaseModule} from 'angularfire2/database'
import {AngularFirestoreModule} from 'angularfire2/firestore'
import {AngularFireAuthModule} from 'angularfire2/auth'
import {AngularFireModule} from 'angularfire2'

import {UserModule, UserService} from './user'
import {FolderModule, FolderService} from './folder'
import {ProjectModule} from './project'
import {AdminModule} from './admin'
import {UISharedModule} from './ui-shared/ui-shared.module'
import {GalleryService} from './ui-shared/gallery/gallery.service'
import {ChatService} from './ui-shared/chat/chat.service'
import {HomeComponent} from './home/home.component'
import {PipeModule} from './pipe/pipe.module'
import {NotFoundComponent} from './not-found/not-found.component'
import {LoaderComponent} from './ui-shared/loader/loader.component'
import {LoaderService} from './ui-shared/loader/loader.service'
import {TableComponent} from './ui-shared/table/table.component'
import {TabsComponent} from './ui-shared/tabs/tabs.component'
import {DownloadComponent} from './download/download.component'
import {CreativeComponent} from './creative/creative.component'
import {DashboardComponent} from './dashboard/dashboard.component'
import {BrandComponent, BrandEditComponent, BrandListComponent} from './brand';
import { ChatComponent } from './chat/chat.component';
import { MessageComponent } from './chat/message/message.component'

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    HomeComponent,
    DownloadComponent,
    LoaderComponent,
    DownloadComponent,
    CreativeComponent,
    DashboardComponent,
    BrandComponent,
    BrandEditComponent,
    BrandListComponent,
    ChatComponent,
    MessageComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    PipeModule,
    UserModule,
    FolderModule,
    ProjectModule,
    AdminModule,
    AppRoutingModule,
    UISharedModule,
  ],
  providers: [
    UserService,
    FolderService,
    GalleryService,
    LoaderService,
    ChatService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/app.module.ts